import { render, staticRenderFns } from "./photoHelp.vue?vue&type=template&id=3c773c68"
import script from "./photoHelp.vue?vue&type=script&lang=js"
export * from "./photoHelp.vue?vue&type=script&lang=js"
import style0 from "./photoHelp.vue?vue&type=style&index=0&id=3c773c68&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c773c68')) {
      api.createRecord('3c773c68', component.options)
    } else {
      api.reload('3c773c68', component.options)
    }
    module.hot.accept("./photoHelp.vue?vue&type=template&id=3c773c68", function () {
      api.rerender('3c773c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/photoHelp.vue"
export default component.exports